import React from "react";
import Grid from "@mui/material/Grid";

const DivisionCardFacilityCmp = (props: any) => {
  if (props == null || props.value.length == 0) return <></>;
  else
    return (
      <>
        <div style={{ margin: "0px 10px 0px 10px" }}>
          <div className="cardBorder borderCOlor mTop20">
            <Grid
              container
              className="row"
              spacing={2}
              style={{ alignItems: "center", width: "98%", margin: "auto" }}
            >
              <Grid item style={{ alignItems: "left", paddingTop: "20px" ,minWidth:'22vh'}}>
                <div>
                  <div className="divisionCardCmp" style={{lineHeight:'1.9',marginLeft:'-2vh' }}>
                    <div className="colorTitle textFont14" style={{maxWidth:'50vh',marginRight:'-1vh'}}>
                      {props.titleCard}
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid
                item
                style={{
                  alignItems: "right",
                  paddingTop: "20px",
                  maxWidth: "20vh",
                  minWidth: "10vh",
                  marginRight:"2vh",
                  
                }}
              >
                <img
                  className="designCard divisionCardTitle"
                  src="images/facilityIcon.png"
                  alt="Red dot"
                />
              </Grid>
              <Grid item xs={12}  sm container style={{ textAlign: "right", paddingTop: "20px",lineHeight:'1.9' ,marginRight:'3vh'}}>
                <Grid style={{ textAlign: "right", fontSize: "14px" }}>
                  <span> مبلغ تسهیلات: </span>
                  <span style={{ marginLeft: "10px", fontWeight: "bold" }}>
                    &nbsp;&nbsp;{" "}
                    {props.existingLoanRequest.toLocaleString()}{" "}
                    (ریال)&nbsp;&nbsp;
                  </span>
                  |<span style={{ marginRight: "10px" }}>تعداد اقساط:</span>
                  <span style={{ fontWeight: "bold" }}>
                    &nbsp;&nbsp;{props.value[0].installmentCount}&nbsp;&nbsp;
                  </span>
                  |<span style={{ marginRight: "10px" }}>فاصله اقساط:</span>
                  <span style={{ fontWeight: "bold" }}>
                    &nbsp;&nbsp;{props.value[0].stepSpaceByMonth}
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
        {/* })} */}
      </>
    );
};

export default DivisionCardFacilityCmp;
